import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 * yearStart: string,
 * yearEnd: string,
 * reportingDueDate: string,
 * thresholdDays: number,
 * paymentDates: string[],
 * totalProjects: number,
 * completeProjects: number }} ReportStatusWidgetListItem
 */

const api = new Api("api/Municipalities/");

/**
 * @param {number} municipalId
 *
 * @returns {Promise<AxiosResponse<ReportStatusWidgetListItem>>}
 */
export const getById = (municipalId) => api.get(`${municipalId}/status/widget`);
